
import { defineComponent } from "vue";
import axios from "axios";
import store from "@/store";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "login",
  data() {
    return {
      btname: "ورود",
      username: "",
      password: "",
      showPassword: false,
      isNullPassword: false,
      isNullUserName: false,
      isNotTrue: false,
    };
  },
  methods: {
    doLogin() {
      const toEnDigit = (s: string): string =>
        s.replace(/[٠-٩۰-۹]/g, (a) => String(a.charCodeAt(0) & 15));
      const password = toEnDigit(this.password);
      let sccess = false;
      if (this.username === "") {
        this.isNullUserName = true;
      } else {
        this.isNullUserName = false;
        sccess = true;
      }
      if (password === "") {
        this.isNullPassword = true;
      } else {
        this.isNullPassword = false;
        sccess = true;
      }
      if (
        sccess == true &&
        this.isNullUserName == false &&
        this.isNullPassword == false
      ) {
        axios
          .post("users/login", {
            username: this.username,
            password: password,
          })
          .then((res) => {
            console.log(res);

            store.commit("Login", res.data.token);
            let role = res.data.user.role;
            localStorage.setItem("role", res.data.user.role);
            localStorage.setItem("firstname",res.data.user.information.first_name);
            localStorage.setItem("lastname", res.data.user.information.last_name);
            if (role === "patient") {
              this.$router.push("/patient/profile");
            } else if (role === "doctor") {
              this.$router.push("/doctor/profile");
            } else if (role === "operator") {
              this.$router.push("/admin/profile");
            }
          })
          .catch((error) => {
            console.log(error);
            this.isNotTrue = true;
          });
      }
    },
  },
});
